import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import ShipGoWelcomeModal from '../components/PartnerPage/ShipGoWelcomeModal';
import './stylesheets/shipgo_welcome_modal.scss';

const STORAGE_KEY = 'shipgo_modal_shown_v1';
const TRIGGER_PARAM = 'from';
const TRIGGER_VALUE = 'shipgo';
const EVENT_NAME = 'go_modal_shown';

const shouldShowModal = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get(TRIGGER_PARAM) !== TRIGGER_VALUE) return false;
    if (window.localStorage.getItem(STORAGE_KEY)) return false;
    return true;
  } catch (e) {
    return false;
  }
};

const trackShown = () => {
  if (typeof window.rudderanalytics?.track !== 'function') return;
  window.rudderanalytics.track(EVENT_NAME, {
    brand: window.gon?.current_brand || 'shipplay',
    source: 'shipgo',
    path: window.location.pathname,
  });
};

const persistShown = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
  } catch (e) {
    // localStorage may be unavailable (private browsing, quota) — fail silently.
  }
};

const ShipGoWelcomeModalRoot = () => {
  const [isOpen, setIsOpen] = useState(true);

  React.useEffect(() => {
    // Persist the moment the modal RENDERS, not when it dismisses — AC-6 says
    // "once a user has seen it, it doesn't show again", and a reload before
    // dismiss used to re-show + re-fire the Rudderstack event (QA defect
    // GSE-12325, 2026-10-08).
    persistShown();
    trackShown();
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return <ShipGoWelcomeModal isOpen={isOpen} onClose={handleClose} />;
};

const mount = () => {
  if (!shouldShowModal()) return;
  const host = document.createElement('div');
  host.id = 'shipgo-welcome-modal-root';
  document.body.appendChild(host);
  ReactDOM.render(<ShipGoWelcomeModalRoot />, host);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
